import styled from '@emotion/styled';

type CardProps = {
  orientation: 'vertical' | 'horizontal' | 'square',
  href?: string,
  block?: boolean,
  minWidth?: string,
  topRightRadius?: boolean;
  topLeftRadius?: boolean;
  bottomRightRadius?: boolean;
  bottomLeftRadius?: boolean;
};

const getRatio = (o: CardProps['orientation']) => {
  switch (o) {
    case 'vertical': return '140%';
    case 'horizontal': return '56%';
    case 'square': return '100%';
  }
};

const Card = styled.div<CardProps>(({ theme, minWidth = '6rem', orientation = 'vertical', topRightRadius = true, topLeftRadius = true, bottomRightRadius = true, bottomLeftRadius = true }) => ({
  lineHeight: theme.font.lineHeight.normal,
  display: 'block',
  position: 'relative',
  paddingBottom: getRatio(orientation),
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderTopRightRadius: topRightRadius ? theme.radius.medium : 0,
  borderTopLeftRadius: topLeftRadius ? theme.radius.medium : 0,
  borderBottomRightRadius: bottomRightRadius ? theme.radius.medium : 0,
  borderBottomLeftRadius: bottomLeftRadius ? theme.radius.medium : 0,
  overflow: 'hidden',
  minWidth,
  backgroundColor: theme.palette.background[500][0],
}));

export default Card;
